import { Component } from '@angular/core';
import { LibOnlineSurveyStatisticsComponent } from '@pishgamrayan/ng-online-survey';
import { PageNames } from 'src/app/configs/page-names.enum';

@Component({
  selector: 'app-online-survey-statistics',
  templateUrl: './online-survey-statistics.component.html',
  standalone: true,
  imports: [LibOnlineSurveyStatisticsComponent],
})
export class OnlineSurveyStatisticsComponent {
  //#region Properties

  pageName = PageNames.onlineSurveyStatistics;

  //#endregion
}
